import { React, PropTypes, css, styled } from '../lib/imports';

import Wrapper from './LayoutWrapper';
import Row from './LayoutRow';
import Header from './LayoutHeader';
import Body from './LayoutBody';
import Footer from './LayoutFooter';

const containerBaseStyles = () => css`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: scroll;
  z-index: 999999;
`;

const Container = styled('div')(containerBaseStyles);

const innerBaseStyles = ({ theme }) => css`
  background: ${theme.colors.white};
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

const Inner = styled('div')(innerBaseStyles);

const Layout = ({ children }) => (
  <Container id='thLayout'>
    <Inner>{children}</Inner>
  </Container>
);

Layout.propTypes = {
  children: PropTypes.node,
};

Layout.defaultProps = {
  children: '',
};

Layout.Wrapper = Wrapper;
Layout.Row = Row;
Layout.Header = Header;
Layout.Body = Body;
Layout.Footer = Footer;

export default Layout;
